/** Only scalar CDN labels are retained; never put loader/XHR objects in analytics. */
export function readResponseServer(networkDetails: unknown): { name: string | null; ip: string | null } {
  const response = networkDetails as {
    getResponseHeader?: (name: string) => string | null;
    headers?: { get?: (name: string) => string | null };
  } | null | undefined;
  function read(name: string): string | null {
    try {
      const value = response?.getResponseHeader?.(name) ?? response?.headers?.get?.(name);
      return typeof value === 'string' && value.trim() ? value.trim().slice(0, 255) : null;
    } catch {
      return null; // A blocked/missing CORS header is unknown, not the previous server.
    }
  }
  return { name: read('X-EDGE-FQDN'), ip: read('X-EDGE-IP') };
}
